export default __webpack_public_path__ + "./images/jo.080bfd7b.png";